function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 18.5,
  cy: 18.5,
  r: 18.5,
  fill: "#2C2B6C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.0558 13.2643C23.9303 13.3933 23.724 13.3962 23.595 13.2708C23.466 13.1453 23.4631 12.939 23.5885 12.81L24.4972 11.8754C24.6227 11.7464 24.829 11.7435 24.958 11.869C25.087 11.9945 25.0899 12.2008 24.9645 12.3298L24.0558 13.2643Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 20.8657,
  cy: 16.3656,
  r: 2.60693,
  stroke: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 20.5397,
  y: 10.5,
  width: 0.651733,
  height: 1.9552,
  rx: 0.325867,
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 16.5082,
  y: 12.3718,
  width: 0.651733,
  height: 1.9552,
  rx: 0.325867,
  transform: "rotate(-46.3259 16.5082 12.3718)",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M23.7957 19.3155C23.6584 19.1992 23.6412 18.9936 23.7575 18.8562C23.8738 18.7189 24.0794 18.7017 24.2168 18.818L25.2117 19.6601C25.3491 19.7763 25.3662 19.982 25.25 20.1193C25.1337 20.2567 24.9281 20.2738 24.7907 20.1576L23.7957 19.3155Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 16.9552,
  y: 16.3656,
  width: 0.651733,
  height: 1.9552,
  rx: 0.325867,
  transform: "rotate(90 16.9552 16.3656)",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 26.7312,
  y: 16.0397,
  width: 0.651733,
  height: 1.9552,
  rx: 0.325867,
  transform: "rotate(90 26.7312 16.0397)",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7848 25.4324H23.8593C24.6377 25.4324 25.2553 25.0086 25.6612 24.475C26.0636 23.946 26.2831 23.2778 26.246 22.7259C26.2085 22.1684 25.8957 21.5826 25.4306 21.1476C25.0084 20.7528 24.4418 20.4644 23.8014 20.4376C23.6505 19.7743 23.4901 19.3541 23.2734 19.0318C23.062 18.7174 22.8032 18.5092 22.5045 18.2689C22.4695 18.2406 22.4339 18.212 22.3977 18.1827C22.0106 17.8687 21.613 17.687 21.1662 17.6237C20.7751 17.5683 20.3595 17.6056 19.8985 17.7069C19.3408 16.8392 18.5064 16.3073 17.6601 16.0733C16.7697 15.8272 15.8369 15.9038 15.181 16.3011C14.5806 16.6649 14.0628 17.0885 13.6956 17.6259C13.3687 18.1043 13.1682 18.6625 13.126 19.3283C11.4629 19.2784 9.75 20.5551 9.75 22.4858C9.75 23.5219 10.3298 24.2631 10.9783 24.7345C11.6176 25.1993 12.3641 25.4324 12.7848 25.4324Z",
  fill: "white",
  stroke: "#2C2B6C",
  strokeWidth: 0.5
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 18.5,
  cy: 18.5,
  r: 12.5,
  stroke: "white",
  strokeWidth: 2
});

function SvgWeather(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeather);
export default __webpack_public_path__ + "static/media/weather.ba6e9e4c.svg";
export { ForwardRef as ReactComponent };